export const PROPERTY_CARD_DETAIL_MAP_CONTENT = {
    LOAD_ERROR: "Nie udało się wczytać mapy. Proszę spróbować później",
    TITLE: "Lokalizacja"
} as const;
export const PROPERTY_CARD_DETAIL_MAP_CONTENT = {
    LOAD_ERROR: "Nie udało się wczytać mapy. Proszę spróbować później",
    TITLE: "Lokalizacja"
} as const;
